<template lang="pug">
  div
    .middle(v-if="total > 0")
      el-pagination(
        layout='prev, pager, next',
        :total="total",
        :page-size="tamanhoPagina",
        :current-page.async="pagina"
        @current-change="alterarPagina"
      )
    div(v-if="showTotalListagem").contador-total
      span Total de registros: {{ total }}
</template>

<script>
import CONFIGS from '@/constants/configs'
const { showTotalListagem } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    pagina: {
      type: Number,
      required: true
    },
    tamanhoPagina: {
      type: Number,
      default: CONFIGS.TAMANHO_PAGINACAO
    }
  },

  data () {
    return {
      CONFIGS,
      showTotalListagem
    }
  },

  methods: {
    alterarPagina (newPage) {
      return this.$emit('changePage', newPage)
    }
  }
}
</script>

<style>
  .middle {
    display: flex;
    justify-content: center;
    margin-top: 1vh;
  }
  .contador-total {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppPaginacao.vue